import React, { Component, PropTypes } from 'react';
import { Provider } from 'react-redux';
import { IntlProvider, addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import zh from 'react-intl/locale-data/zh';
import MaterialThemeProvider from './MaterialThemeProvider';
import Locales from '../utils/Locales';

addLocaleData(en);
addLocaleData(zh);

export default class Wrapper extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    children: PropTypes.element,
    locales: PropTypes.shape({
      en: PropTypes.object,
      zh: PropTypes.object
    }).isRequired
  };

  constructor(props) {
    super(props);

    this.locales = new Locales({
      en: this.props.locales.en,
      zh: this.props.locales.zh
    });
  }

  render() {
    const browserLang = this.props.lang; // Property tag html
    const messages = this.locales.getTranslations(browserLang);

    return <Provider store={this.props.store}>
      <IntlProvider locale={this.locales.getReactIntlCode(browserLang)} messages={messages}>
        <MaterialThemeProvider>
          { this.props.children }
        </MaterialThemeProvider>
      </IntlProvider>
    </Provider>;
  }
}



// WEBPACK FOOTER //
// ./src/app/Wrapper.js